module.exports = __webpack_public_path__ + "assets/ca1e4a79eeeab25d05d31bf01d08a131.png";